export default "__VITE_ASSET__DH0Y5wss__"